import { motion } from "framer-motion";
import { PageProps, graphql } from "gatsby";
import React from "react";
import Layout from "@components/common/Layout";
import { PageContextModel } from "@models/page";

export interface TermsDataModel {
  strapiTerm: {
    title: string;
    id: string;
    content: {
      data: { childMarkdownRemark: { html: string } };
    };
  };
}

const TermPage = (props: PageProps<TermsDataModel, PageContextModel>) => {
  const { content } = props?.data?.strapiTerm ?? {};

  return (
    <Layout>
      <div className="flex flex-col items-center py-12 md:py-[60px] xl:py-20">
        <div className="px-4 md:px-24 xl:px-[250px] py-20">
          <motion.div
            dangerouslySetInnerHTML={{
              __html: content?.data?.childMarkdownRemark?.html ?? "<></>",
            }}
            className="prose"
          />
        </div>
      </div>
    </Layout>
  );
};
export default TermPage;

export const query = graphql`
  query TermPage($slug: String) {
    strapiTerm(slug: { eq: $slug }) {
      id
      title
      content {
        data {
          childMarkdownRemark {
            html
          }
        }
      }
    }
  }
`;
